import FeatureCardSoftware from "./FeatureCardSoftware";
import { motion } from "framer-motion";
import icon1 from "../assets/Icon-1.png";
import icon2 from "../assets/Icon-2.png";
import icon3 from "../assets/Icon-3.png";
import icon4 from "../assets/Icon-4.png";
import { Helmet } from "react-helmet-async";




export default function HighlightSoftware() {
  const icons = [icon1, icon2, icon3, icon4];

  const features = [
    {
      
      title: "Key Features of Game Config. for Administrators",
      color: "text-black",
      features: [
        { title: "Manage Slot Games", description: " Select, activate, or deactivate specific slot machines." },
        { title: "Control Purchases & Jackpots", description: " Toggle in-game purchases and jackpot rewards on or off." },
        { title: "Adjust Payout Settings", description: " Set payout levels (high, medium, low) based on RTP and game mechanics." },
        { title: "Bet Customization", description: " Define bet multipliers, max bet limits, and exclude specific bet values." },
        { title: "Set Default Bets", description: "Establish a minimum starting bet for players." },
      ],
    },
    {
      

      title: "Mini Jackpot Configuration Features",
      color: "text-black",
      features: [
        { title: "Enable/Disable Mini Jackpot", description: "Toggle its availability for gameplay." },
        { title: "Set Starting & Maximum Values", description: "Define initial and cap limits for the jackpot amount." },
        { title: " Adjust Current Value", description: "Modify the jackpot in real-time as needed." },
        { title: "Interest Rate Control", description: "Set the percentage of each spin contributing to jackpot growth." },
        { title: "Minimum Bet Requirement", description: "Define the minimum wager needed to qualify for the jackpot." },
      ],
    },
    {
    

      title: "Device Config Features for Administrators",
      color: "text-black",
      features: [
        { title: "Bill Acceptor Setup", description: "Connect and configure devices like JCM UBA 1055, MEI SCAdvance, GBA GV1, and NV200." },
        { title: "Serial Port Selection", description: "Choose communication ports for seamless device connections." },
        { title: " Printer Configuratio", description: " Connect printers like Transact Epic Edge and Epice950." },
        { title: " Flexible Hardware Integration", description: "Efficiently manage and integrate bill acceptors and printers." },

      ],
    },
    {
      

      title: "Key Report Section Features",
      color: "text-black",
      features: [
        { title: "Bills In", description: "JCM UBA 1055, MEI SC Advance, GBA GV1, etc." },
        { title: "Jackpot Report", description: "Transact Epic Edge & Epic 950 for smooth printing." },
        { title: "Spin Report", description: "Optimal performance for graphics, logic, and device control." },
        { title: " Voucher Out", description: "Advanced security and reliable metrics." },
        { title: " Accounting", description: "Access comprehensive financial records, including lifetime meter readings, total vouchers, bills accepted, net value, and percentages." },

      ],
    },
    ,
    {
      

      title: "Slot Game Platform Configuration Features",
      color: "text-black",
      features: [
        { title: "Unique ID Generation", description: "Set Machine Serial Number, Terminal ID, Store ID, and Store Name." },
        { title: "Low Balance Timer:", description: "Trigger notifications based on a set time limit." },
        { title: "Cash & Balance Settings", description: "Define cash-out increments, max voucher value, and bill limits." },
        { title: " Meter & Win Limits", description: "Configure meter tick updates and set win thresholds for attendant calls." },
        { title: " System Management", description: "djust date, time, screen resolution, and internet connectivity for smooth operation." },

      ],
    },
    {
      

        title: "Core Features of Our Land Slot Management System",
        color: "text-black",
        features: [
          { title: "User-Friendly Dashboard", description: "Manage terminals, jackpots, and devices with real-time insights." },
          { title: "Easy Configuration ", description: "Quick setup for serial IDs, machine settings, and bill limits." },
          { title: "Flexible Game & Jackpot Controls", description: "Customize gameplay and manage jackpots effortlessly." },
          { title: " Seamless Device Integration", description: "Simple connection for bill acceptors and printers." },
          { title: " Detailed Reporting ", description: "Track spins, jackpots, revenue, and performance metrics." },
  
        ],
      },
  ];

  return (
    <motion.section className="mb-1 ">
      <div>
<Helmet>
        {/* <title>Land Slot Game Services | Custom Slot Game Development</title>
        <meta name="description" content="Expert land slot game development services, including custom game design, and integration. Boost your casino with premium slot solutions!" /> */}
        {/* <meta name="keywords" content="slots, slot games, online slots, casino slots, jackpot" />
        <meta property="og:title" content="Play Exciting Slot Games" />
        <meta property="og:description" content="Try your luck with our top-rated online slots!" />
        <meta property="og:image" content="https://example.com/slots-banner.jpg" /> */}
      </Helmet>


      <h1 className="text-3xl md:text-[2.6rem] font-bold  mb-2 sm:mb-6 lg:mb-14 z-40 relative min-h-[3rem] bg-black text-transparent bg-clip-text ">
        Key Highlights
      </h1>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-6 ">
        {features.map((feature, index) => (

          <FeatureCardSoftware key={index} {...feature} icon={icons[index % icons.length]} />
        ))}
      </div>
      </div>
   
    </motion.section>
  );
}
